module.exports = new __parcel__URL__("toolbox-darkmode.b2678524.svg").toString();